import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        form: '=',
        disabled: '=',
        haswell: '=',
        metaFieldGroups: '=',
        questionMetaFields: '=',
        sites: '=',
        questionPools: '=',
        isModal: '='
    },
    template
})

export default class {
    constructor (lodash, $timeout, FORMS_META_FIELD_TYPE_ENUM, MetaFieldResource, TokenService, PrivilegeService,
        FormService, FORMS_SITE_ACCESS_ENUM, SiteService, $translate, QuestionTagResource, QuestionCategoryResource,
        $rootScope, $scope) {
        this.lodash = lodash;
        this.$timeout = $timeout;
        this.FORMS_META_FIELD_TYPE_ENUM = FORMS_META_FIELD_TYPE_ENUM;
        this.MetaFieldResource = MetaFieldResource;
        this.meta = [];
        this.groupMetaIds = [];
        this.FORMS_SITE_ACCESS_ENUM = FORMS_SITE_ACCESS_ENUM;
        this.PrivilegeService = PrivilegeService;
        this.FormService = FormService;
        this.SiteService = SiteService;
        this.$translate = $translate;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.activeLanguage = TokenService.getActiveLanguage();
        this.QuestionTagResource = QuestionTagResource;
        this.QuestionCategoryResource = QuestionCategoryResource;
        this.categoryNameKeyword = '';
        this.categories = {};
        this._searchDebounceTimer = null;

        const unsubscribe = $rootScope.$on('question:sitesUpdated', (event, sites) => {
            this.form.model.sites = sites;
            this.initMultiSelect();
        });
        $scope.$on('$destroy', unsubscribe);
    }

    $onInit () {
        this.tooltipTexts = {
            access: this.$translate.instant('question.Define the Sites that can access the question')
        };

        if (!this.form.model.questionMetaFieldGroupIds) {
            this.form.model.questionMetaFieldGroupIds = {};
        }

        this.lodash.forEach(this.form.model.metaGroups, (groupModel, key) => {
            this.form.model.questionMetaFieldGroupIds[key] = groupModel.metaGroupId;
        });

        this.models = {
            selected: null,
            list: []
        };

        if (this.form.model.questionMetaFieldGroupIds) {
            this.lodash.forEach(this.form.model.questionMetaFieldGroupIds, (groupId, key) => {
                this.addItem();
                this.loadMeta(key);
            });
        }

        this.canManageForm = this.FormService.canManageForm(this.form.model);
        this.canManageSiteAccess = this.PrivilegeService.isCompanyAdmin()
            || !this.form.model.id
            || (this.canManageForm && this.form.model.sites && this.form.model.sites.length === 1);
        this.initMultiSelect();
        this.initTags();
        this.manageQuestionPoolAndCategory();
    }

    initTags () {
        if (this.form.model.tags && !this.form.model.tagsForm) {
            this.form.model.tagsForm = [];
            this.tags = this.lodash.reduce(this.form.model.tags, (result, tag) => {
                this.form.model.tagsForm.push({ tag: tag.tag });
                result.push(tag.tag);
                return result;
            }, []);

            return;
        }

        if (this.form.model.tagsForm) {
            this.tags = this.lodash.reduce(this.form.model.tagsForm,
                (result, tag) => [...result, tag.tag], []);
            return;
        }
        this.tags = [];
    }

    addItem () {
        this.models.list.push({});
    }

    removeItem (key) {
        this.models.list.pop(key);
        this.meta.pop(key);

        this.lodash.forEach(this.groupMetaIds[this.form.model.questionMetaFieldGroupIds[key]], (metaId) => {
            delete this.questionMetaFields[metaId];
        });
        delete this.groupMetaIds[this.form.model.questionMetaFieldGroupIds[key]];
        delete this.form.model.questionMetaFieldGroupIds[key];

        this.sortMeta();
    }

    sortMeta () {
        let i = 0;
        this.lodash.forEach(this.form.model.questionMetaFieldGroupIds, (value) => {
            this.form.model.questionMetaFieldGroupIds[i] = value;
            this.loadMeta(i);
            i++;
        });
    }

    loadMeta (key) {
        if (!this.form.model.questionMetaFieldGroupIds[key]) {
            this.meta[key] = [];
            return;
        }

        this.MetaFieldResource.query({
            metaFieldGroupId: this.form.model.questionMetaFieldGroupIds[key],
            expand: 'metaFieldValues,activeI18n,metaFieldI18ns,metaFieldValuesI18ns'
        }).$promise.then((response) => {
            this.groupMetaIds[this.form.model.questionMetaFieldGroupIds[key]] = this.lodash.reduce(response, (origin, meta) => {
                origin.push(meta.id);
                return origin;
            }, []);

            this.meta[key] = this.lodash.reduce(response, (origin, meta) => {
                if (meta.type === this.FORMS_META_FIELD_TYPE_ENUM.KEYS.SELECT) {
                    meta.metaSelectFieldDefaultLanguageValues = this.lodash.filter(meta.metaFieldValuesI18ns, (metaFieldValue) => {
                        return metaFieldValue.language === this.defaultLanguage;
                    });
                }
                origin.push(meta);
                return origin;
            }, []);
        });

        this.form.model.questionMetaFieldGroupIds[key] = parseInt(this.form.model.questionMetaFieldGroupIds[key], 10);
    }

    initMultiSelect () {
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };
        const siteOptions = this.getSiteOptions();
        const selectedOptions = this.getSelectedSiteOptions(siteOptions);

        this.siteFilter = {
            models: selectedOptions,
            options: siteOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 5,
                smartButtonTextConverter: (itemText) => itemText
            },
            events: {
                onItemDeselect: this.getItemCallback(),
                onItemSelect: this.getItemCallback()
            },
            translations: {
                buttonDefaultText: this.$translate.instant('filter.Select')
            }
        };
    }

    getSiteOptions () {
        const siteOptions = [];
        const getSiteOption = ({ id, name }) => ({
            value: id,
            label: name
        });


        if (this.showAllSites()) {
            siteOptions.push(this.allSitesOption);
        }

        this.lodash.forEach(this.sites, site => {
            siteOptions.push(getSiteOption(site));
        });

        if (this.form.model.sites && this.form.model.sites.length) {
            this.lodash.forEach(this.form.model.sites, site => {
                siteOptions.push(getSiteOption(site));
            });
        }

        return this.lodash.uniqBy(siteOptions, option => option.value);
    }

    showAllSites () {
        return this.SiteService.hasAccessToAllSites(this.sites)
        || this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
    }

    getSelectedSiteOptions (siteOptions) {
        let selectedOptions = [];

        if (this.form.model.sites && this.form.model.sites.length) {
            const selectedSiteIds = this.form.model.sites.map(site => site.id);
            selectedOptions = siteOptions.filter(option => this.lodash.includes(selectedSiteIds, option.value));
        }
        else if (this.form.model.questionSiteIds && this.form.model.questionSiteIds.length) {
            selectedOptions = siteOptions.filter(option => this.lodash.includes(this.form.model.questionSiteIds, option.value));
        }
        else if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            selectedOptions.push(this.allSitesOption);
        }
        return selectedOptions;
    }

    getItemCallback () {
        return item => {
            const { siteFilter } = this;

            if (item.value === null) {
                siteFilter.models = [this.allSitesOption];
                this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
            else {
                siteFilter.models = siteFilter.models.filter(model => model.value !== null);
                this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            }

            this.setSites(siteFilter.models);
            this.setQuestionSiteIds();
        };
    }

    setSites (sites) {
        this.form.model.sites = [];
        const cb = site => {
            return {
                id: site.value,
                name: site.label
            };
        };

        if (sites && sites.length) {
            this.lodash.forEach(sites, site => {
                this.form.model.sites.push(cb(site));
            });
            return;
        }
        this.form.model.sites.push(this.allSitesOption);
    }

    setQuestionSiteIds () {
        if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            this.form.model.questionSiteIds = [];
            return;
        }
        this.form.model.questionSiteIds = this.siteFilter.models.map(siteOption => siteOption.value);
    }

    manageQuestionPoolAndCategory () {
        if (this.form.model.questionPoolId) {
            this.form.model.questionPoolId = this.form.model.questionPoolId.toString();
        }
        if (this.form.model.categoryId) {
            this.QuestionCategoryResource.get({ id: this.form.model.categoryId }).$promise.then((response) => {
                this.categoryNameKeyword = response.name;
            });
            this.form.model.categoryId = this.form.model.categoryId.toString();
        }
    }

    search () {
        this.form.model.categoryId = null;

        if (this._searchDebounceTimer) {
            this.$timeout.cancel(this._searchDebounceTimer);
            this._searchDebounceTimer = null;
        }

        if (this.categoryNameKeyword.length < 3) {
            return;
        }

        this._searchDebounceTimer = this.$timeout(() => {
            this._doSearch(this.categoryNameKeyword);
        }, 300);
    }

    _doSearch (keyword) {
        this.QuestionCategoryResource.query({ keyword, pageSize: 0 }).$promise.then((response) => {
            this.categories = response;
            this.searchCompleted = true;
        });
    }

    onInputFocus () {
        this._doSearch(this.categoryNameKeyword || '');
    }

    getIsNoResults () {
        return this.categoryNameKeyword.length >= 3 && !this.categories.length && this.searchCompleted;
    }

    selectCategory (category) {
        this.form.model.categoryId = category.id;
        this.categoryNameKeyword = category.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/meta/index.js